import { useState, useEffect } from 'react';

// Static snapshots are refreshed by GitHub Actions from Supabase-backed functions.
// The browser reads these files only, which keeps the UI fast and deterministic.
const STATIC_FILES = {
  lifetimeStats: './data/lifetime_streaming_stats.json',
  annualRecaps:  './data/annual_recaps.json',
  artistSummary: './data/artist_summary.json',
  concertData:   './data/concerts.json',
};

const fetchStatic = async (path) => {
  const res = await fetch(path);
  if (!res.ok) throw new Error(`Failed to load ${path}`);
  return res.json();
};

export const useData = () => {
  const [lifetimeStats, setLifetimeStats] = useState(null);
  const [annualRecaps, setAnnualRecaps]   = useState(null);
  const [artistSummary, setArtistSummary] = useState(null);
  const [concertData, setConcertData]     = useState(null);
  const [loading, setLoading]             = useState(true);
  const [error, setError]                 = useState(null);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        const [staticLifetime, staticRecaps, staticArtists, staticConcerts] =
          await Promise.all([
            fetchStatic(STATIC_FILES.lifetimeStats),
            fetchStatic(STATIC_FILES.annualRecaps),
            fetchStatic(STATIC_FILES.artistSummary),
            fetchStatic(STATIC_FILES.concertData),
          ]);

        if (cancelled) return;
        setLifetimeStats(staticLifetime);
        setAnnualRecaps(staticRecaps);
        setArtistSummary(staticArtists);
        setConcertData(staticConcerts);
        setLoading(false);

      } catch (err) {
        if (!cancelled) {
          console.error('Error loading static data:', err);
          setError(err.message);
          setLoading(false);
        }
      }
    };

    run();
    return () => { cancelled = true; };
  }, []);

  return { lifetimeStats, annualRecaps, artistSummary, concertData, loading, error };
};
